import React from 'react';
import { skills } from '../data.js';

const SkillTags = ({ items }) => (
  <div className="flex flex-wrap gap-2 mt-2">
    {items.map((skill, idx) => <span key={idx} className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm">{skill}</span>)}
  </div>
);

export default function Skills({ sectionBg }) {
  const cardBg = sectionBg === "bg-gray-50" ? "bg-white" : "bg-gray-50";

  return (
    <section id="skills" className={sectionBg + ' py-16'}>
    <div className="max-w-6xl mx-auto px-6">
      <h2 className="text-3xl font-bold mb-8 text-center">Skills</h2>
      <div className={`p-6 rounded-xl ${cardBg} shadow-md`}>
        <div className="mb-6">
          <h3 className="font-semibold">Languages</h3>
          <SkillTags items={skills.languages}/>
        </div>
        <div className="mb-6">
          <h3 className="font-semibold">Tech</h3>
          <SkillTags items={skills.tech}/>
        </div>
        <div>
          <h3 className="font-semibold">Non-Tech</h3>
          <SkillTags items={skills.nonTech}/>
        </div>
      </div>
    </div>
    </section>
  );
}
